/* Hardcoded door builder rules requested by the client.
 * Keep every client specific option filter here, so there is one place
 * to look at when catalog options are hidden or limited on the FE.
 */

import {
  DoorBuilderOptionsEnum,
  LIPPED_DOOR_EDGES,
} from 'order/wizard/orderStyles/enums/DoorBuilderOptionsEnum';

import { SelectOptionProps } from 'shared/interface/SelectOptionProps';

const normalize = (label?: string) => (label ?? '').trim().toUpperCase();

export const isLippedDoorEdge = (doorEdge?: SelectOptionProps | null) =>
  !!doorEdge && LIPPED_DOOR_EDGES.includes(normalize(doorEdge.label));

export const hasLippedDoorEdge = (
  doorEdges: (SelectOptionProps | null | undefined)[]
) => doorEdges.some(isLippedDoorEdge);

interface HingeTypeRuleContext {
  isLippedDoorEdgeSelected: boolean;
  isUserCSR: boolean;
}

// Lipped door edge (LIP-C, LIP-D, LIP-G) - dealer can pick only Knife hinge, CSR can pick Knife and Special.
export const filterHingeTypeOptions = (
  hingeTypeOptions: SelectOptionProps[] | null | undefined,
  { isLippedDoorEdgeSelected, isUserCSR }: HingeTypeRuleContext
) => {
  if (!hingeTypeOptions || !isLippedDoorEdgeSelected) {
    return hingeTypeOptions;
  }

  const allowedHingeTypes: string[] = isUserCSR
    ? [DoorBuilderOptionsEnum.KNIFE, DoorBuilderOptionsEnum.SPECIAL]
    : [DoorBuilderOptionsEnum.KNIFE];

  return hingeTypeOptions.filter((hingeTypeOption) =>
    allowedHingeTypes.includes(normalize(hingeTypeOption.label))
  );
};
